import ProgressSidebar from '/@/components/bayer/progress-sidebar';
import type { RecommendationSidebarProps } from '/@/types/recommendation-create';

function RecommendationMobileSidebar({ steps, activeStep, setActiveStep }: RecommendationSidebarProps) {
    const mappedSteps = steps.map((step, i) => ({
        key: step.sidebarName || i,
        index: i + 1,
        active: activeStep < i + 1,
        name: step.sidebarName,
        summary: activeStep > i ? step.sidebarSummary : undefined,
        onClick: () => setActiveStep(i),
        disabled: activeStep !== i,
    }));
    return <ProgressSidebar steps={mappedSteps} activeStep={activeStep} />;
}

export default RecommendationMobileSidebar;
